import type { ReactNode } from "react";

export const inputClass =
  "w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-800 placeholder:text-foreground-400 transition-colors focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100";

export const labelClass = "mb-1.5 block text-sm font-label font-medium text-foreground-700";

interface FieldProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  optional?: boolean;
  hint?: string;
  error?: string;
  full?: boolean;
  children: ReactNode;
}

export function Field({
  label,
  htmlFor,
  required,
  optional,
  hint,
  error,
  full,
  children,
}: FieldProps) {
  return (
    <div className={full ? "sm:col-span-2" : ""}>
      <label htmlFor={htmlFor} className={labelClass}>
        {label} {required && <span className="text-primary-600">*</span>}
        {optional && <span className="text-foreground-400">(opcional)</span>}
      </label>
      {children}
      {hint && !error && <p className="mt-1 text-xs text-foreground-500">{hint}</p>}
      {error && (
        <p className="mt-1 flex items-center gap-1 text-xs text-primary-700">
          <i className="ri-error-warning-line text-sm leading-none" aria-hidden="true"></i>
          {error}
        </p>
      )}
    </div>
  );
}

export function StepShell({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <div>
      <h2 className="text-xl font-heading font-bold text-foreground-950 md:text-2xl">{title}</h2>
      {description && (
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{description}</p>
      )}
      <div className="mt-6">{children}</div>
    </div>
  );
}

export function SectionCard({
  title,
  icon,
  children,
  action,
}: {
  title: string;
  icon?: string;
  children: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h3 className="flex items-center gap-2 text-base font-heading font-semibold text-foreground-950">
          {icon && (
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className={`${icon} text-base leading-none`} aria-hidden="true"></i>
            </span>
          )}
          {title}
        </h3>
        {action}
      </div>
      {children}
    </div>
  );
}